import React from "react";
import StoryCard19 from "../story-card19";
import "./top-news-latest.m.css";

function TopNewsLatest({ stories }) {
  return (
    <div>
      {stories?.slice(1, 4).map((item, index) => (
        <div key={index} styleName="latest-card">
          <StoryCard19 story={item} />
        </div>
      ))}
    </div>
  );
}

export default TopNewsLatest;
